import React from 'react'

const SimpleSelect = ({values, value, onChange, style, customClassName}) => {
    return (
        <select className={customClassName} style={style} onChange={onChange} value={value.value}>
            {values.map( v => {
                return (<option key={v.value}  value={v.value}>{v.label}</option>)
            })}
        </select>
    )
}

export default SimpleSelect